export const API_URL = "/api_member/orgs/:org_id/projects";
export const LINK_URL = "/orgs/:org_id/projects";
export const ROWS_PER_PAGE = 10;

export const LIST_COLUMNS = [
  { id: "name", label: "Project Name", type: "link" },
  { id: "description", label: "Description" },
  { id: "project_status", label: "Status" },
  { id: "actions", label: "Actions" },
]

export const CREATE_FIELDS = []
export const CREATE_FORM_DATA_DEFAULT = {}
export const UPDATE_FIELDS = []
export const SHOW_FIELDS = [
  { name: "name", label: "Project Name", type: "text" },
  { name: "description", label: "Description", type: "text" },
  { name: "project_status", label: "Status", type: "text" },
]
export const ADVANCE_SEARCH_FIELDS = []
